export default {
  STRETCHED: 'stretched',
};
